export default "__VITE_ASSET__CDS_sEQa__"